import { VariableMetadata } from '../../types/model';
import { groupVariables } from '../../utils/variableMetadata';
import VariableSelect from './VariableSelect';
import OptionToggle from './OptionToggle';

interface Props {
  value: string;
  onChange: (value: string) => void;
  paths: string[];
  metadata: Record<string, VariableMetadata>;
  names: Record<string, string>;
}

export default function OutputVariableSelect({ value, onChange, paths, metadata, names }: Props) {
  const [form, variable] = value.split('.');
  const variables = Array.from(new Set(paths.map(path => path.split('.')[1])));
  const forms = (key: string) => ['baseline', 'counterfactual', 'hats'].filter(f => paths.includes(`${f}.${key}`));
  const available = forms(variable);
  return <div className="output-variable-controls">
    <div className="variable-picker">
      <span>Variable</span>
      <div className="variable-picker-control">
        <VariableSelect value={variable} groups={groupVariables(variables, metadata, names)}
          minWidth="min(280px, 100%)" onChange={key => {
            const next = forms(key);
            onChange(`${next.includes(form) ? form : next[0]}.${key}`);
          }} />
      </div>
    </div>
    <OptionToggle label="Output representation" value={form}
      options={available.map(f => ({ value: f, label: f === 'baseline' ? 'Baseline' : f === 'counterfactual' ? 'Counterfactual' : 'Change (%)' }))}
      onChange={next => onChange(`${next}.${variable}`)} />
  </div>;
}
